import { Box, Heading, Text } from '@chakra-ui/react';

const TimeBox = ({ props, resumeIndex }) => {
  const resume = props.stateProps.dataToSave.saved.resumes[resumeIndex];
  const resumeDate =
    typeof resume['resume_date'] !== 'undefined'
      ? new Date(resume['resume_date'])
      : new Date();
  const resumeDateFormatted = resumeDate.toLocaleDateString('en-us');

  return (
    <Box width='fit-content'>
      <Heading variant="b12">Last Updated</Heading>
      <Text variant="t16">{resumeDateFormatted}</Text>
    </Box>
  );
};

export default TimeBox;
